import React, { Component } from 'react';
import { Box, Paper, Grid, Fab } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import AdvancesList from './AdvancesList';
import SearchBar from '../../common/SearchBar';
import { InputSelectMulti, InputSelectNative } from '../../common/Form';
import TitleWithEndAction from '../../common/TitleWithEndAction';
import AdvanceReturnsList from './AdvanceReturnsList';
import { AddRounded } from '@mui/icons-material';
import SuppliersAdvanceForm from '../Suppliers/SuppliersAdvanceForm';

class AdvancesGeneral extends Component {
    state = { 
        searchBank: "",
        searchBar: "",
        searchUser: {value: "", label: ""},
        searchMode: "",
        searchSupplier: {value: "", label: ""},
        index: 0,
        openForm: false,
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        })
    }
    handleChangeMulti = (option, field) => {
        if(option){
            this.setState({                
                [field]: option,
            })
        } else {
            this.setState({
                [field]: {label: "", value: ""},
            })
        }
    }
    render() {
        const { BANKS, USERS, SUPPLIERS } = this.props;
        const { openForm } = this.state;
        return (
            <Box>
                {openForm &&
                    <SuppliersAdvanceForm open={openForm} handleClose={() => this.setState({  openForm: false})} {...this.props} />
                }
                <TitleWithEndAction
                    title={this.state.index === 0 ? "Liste des Acomptes fournisseurs" : "Liste des Retours sur Acompte"}
                    action={() => this.props.openFormDownload("/extract/advances")}
                    actionTitle="Télécharger" 
                    disabled={this.props.downloading}
                >
                    <Fab
                        color="secondary"
                        variant="contained"
                        onClick={() => this.setState({ openForm: true})}
                        size="small"
                    >
                        <AddRounded />
                    </Fab>

                </TitleWithEndAction>
                
                <SwipeableTabs
                    returnIndex={(index) => this.setState({ index })}
                    labels={["Acomptes", "Retours"]}
                    searchPaper={
                        <Paper >
                            <Box p={2} >
                                <Grid container >
                                    <Grid item xs={12} sm={6} >
                                        <InputSelectMulti
                                            label="Banque"
                                            name="searchBank"
                                            value={this.state.searchBank}
                                            labelWidth={60} 
                                            options={Object.values(BANKS).map( item => ({
                                                label: item.bank_name,
                                                value: item.bank_id,
                                                disabled: Array.isArray(this.state.searchBank) && !!this.state.searchBank.find(element => element.value === item.bank_id)
                                            }))}
                                            onChange={(option) => this.handleChangeMulti(option, "searchBank")}
                                            isMulti
                                        />
                                    </Grid>  
                                    <Grid item xs={12} sm={6} >
                                        <SearchBar 
                                            handleChange={this.handleChange} 
                                            label="Référence Paiement"
                                            searchValue={this.state.searchBar}
                                            name="searchBar"
                                        />
                                    </Grid>   
                                    <Grid item xs={12} sm={6} >
                                        <InputSelectNative
                                            label="Mode de Paiement"
                                            name="searchMode"
                                            onChange={this.handleChange}
                                            value={this.state.searchMode}
                                            labelWidth={150} 
                                            options={[
                                                <option value="ESPECES">ESPECES</option>,
                                                <option value="CHEQUE">CHEQUE</option>,
                                                <option value="PRELEVEMENT">PRELEVEMENT</option>,
                                                <option value="VIREMENT">VIREMENT</option>,
                                                <option value="GAB">GAB</option>,
                                                <option value="MOBILE MONEY">MOBILE MONEY</option>,
                                                <option value="COLLAB">COLLAB</option>,
                                                <option value="ACOMPTE">ACOMPTE</option>,
                                            ]}
                                        />
                                    </Grid>  
                                    {/* {this.state.index === 0 &&
                                    <Grid item xs={12} sm={6} >
                                        <InputSelectMulti
                                            label="Utilisateur"
                                            id="searchUser"
                                            options={Object.values(USERS).map( item => ({
                                                label: `${item.email} - ${item.lastname.toUpperCase()} ${item.username}`,
                                                value: item.user_id,
                                                disabled: Array.isArray(this.state.searchUser) && !!this.state.searchUser.find(element => element.value === item.user_id)
                                            }))}
                                            value={this.state.searchUser}
                                            onChange={(option) => this.handleChangeMulti(option, "searchUser")}
                                            isMulti
                                        />
                                    </Grid>  
                                    }
                                    {this.state.index === 1 && */}
                                    <Grid item xs={12} sm={6} >
                                        <InputSelectMulti
                                            label="Fournisseur"
                                            id="searchSupplier"
                                            options={Object.values(SUPPLIERS).map( item => ({
                                                label: `${item.supplier_name}`,
                                                value: item.supplier_id,
                                                disabled: Array.isArray(this.state.searchSupplier) && !!this.state.searchSupplier.find(element => element.value === item.supplier_id)
                                            }))}
                                            value={this.state.searchSupplier}
                                            onChange={(option) => this.handleChangeMulti(option, "searchSupplier")}
                                            isMulti
                                        />
                                    </Grid>  
                                    {/* } */}
                                </Grid>  
                            </Box>  
                        </Paper>
                    }
                >
                    <AdvancesList
                        {...this.props}
                        {...this.state}
                        // handleChange={this.handleChange}
                    />
                    <AdvanceReturnsList
                        {...this.props}
                        {...this.state}
                        // handleChange={this.handleChange}
                    />
                </SwipeableTabs>
            </Box>
        );
    }
}

export default AdvancesGeneral;